import { IRouterProps } from "@Interface/Login"
import { AiOutlineTrophy } from "react-icons/ai";
import { IoSettingsOutline } from "react-icons/io5";
import { LuScanLine } from "react-icons/lu";
import { LiaWalletSolid } from "react-icons/lia";
import withRouter from "../../common/withRouter"
import { useAppDispatch, useTypedSelector } from "@redux/store";
import React from "react";
import { operations, selectors } from "@redux/index";
import { shallowEqual } from "react-redux";
import { FiHome } from "react-icons/fi";
import { t } from "@utils/translations";
import { pushToDataLayer } from "@utils/gtm";

const Footer: React.FC<IRouterProps> = ({ router }) => {
  const dispatch = useAppDispatch();

  const { loggedInDetails, selectedMenu } = useTypedSelector((state) => ({
    loggedInDetails: selectors.loggedInDetails(state),
    selectedMenu: selectors.selectedMenu(state)
  }), shallowEqual);

  const onClickMenu = (menuName: string) => {
    router.navigate(`/${menuName}`)
  }

  const submitDatalayerEvent =(ctaClick: string)=>{
    pushToDataLayer({
      'event': 'eventTracker',
      'custom_event_name': 'cta_click',
      'cta_name': ctaClick ?? '',
      'cta_type': 'button',
      'cta_position': 'footer'
    });
  }

  return (
    <>
      <div className="max-w-[500px] fixed bottom-0 w-full rounded-t-xl bg-white shadow-[0px_-4px_6px_-2px_rgba(0,0,0,0.20),0px_-10px_20px_-4px_rgba(0,0,0,0.06)] z-10">
        <div className="flex w-full h-19 items-center">
          <span
            className={`flex flex-col gap-1 flex-1 items-center p-[7px_0] text-primary ${selectedMenu === 'home' ? 'border-b-4 border-(--button-green)' : ''
              }`}
            onClick={() => {
              onClickMenu('home')
              submitDatalayerEvent('home')
            }}
          >
            <FiHome
              className="text-3xl m-auto"
              color={selectedMenu === 'home' ? 'var(--button-green)' : 'gray'}
            />
            <p className={`m-0 p-0 font-bold text-[10px] text-center ${selectedMenu === 'home' ? 'text-(--button-green)' : 'text-gray-500'}`}>
              {t('menu.home')}
            </p>
          </span>

          <span className={`flex flex-col gap-1 flex-1 items-center p-[7px_0] ${selectedMenu === 'rewards' ? 'border-b-4 border-(--button-green)' : ''}`}
            onClick={() => {
              onClickMenu('rewards')
              submitDatalayerEvent('rewards')
            }}
          >
            <AiOutlineTrophy
              className="text-3xl m-auto text-primary"
              color={selectedMenu === 'rewards' ? 'var(--button-green)' : 'gray'}
            />
            <p className={`m-0 p-0 font-bold text-[10px] text-center ${selectedMenu === 'rewards' ? 'text-(--button-green)' : 'text-gray-500'}`}>
              {t('menu.rewards')}
            </p>
          </span>

          <span
            className={`flex flex-col items-center w-20 ${loggedInDetails?.isThemeApplied ? 'p-[4px_0px] gap-0' : 'p-[10px_3px] gap-1 '}  text-white rounded-full bg-linear-to-b from-[#125F30] to-[#489D2F] -translate-y-[15px] border-3 border-white box-shadow`}
            onClick={() => {
              onClickMenu('upload-receipt')
              submitDatalayerEvent('upload receipt')
            }}
          >
            <LuScanLine className="text-3xl m-auto" />
            <p className="m-0 p-0 font-bold text-[10px] text-center text-white">{t('menu.upload')}</p>
          </span>

          <span className={`flex flex-col gap-1 flex-1 items-center p-[7px_0] ${selectedMenu === 'vouchers' ? 'border-b-4 border-(--button-green)' : ''}`}
            onClick={() => {
              submitDatalayerEvent('vouchers')
              router.navigate('/reward-history')
              dispatch(operations.dispatchSelectedMenu('vouchers'))
            }}
          >
            <LiaWalletSolid
              className="text-3xl m-auto text-primary"
              color={selectedMenu === 'vouchers' ? 'var(--button-green)' : 'gray'}
            />
            <p
              className={`m-0 p-0 font-bold text-[10px] text-center ${selectedMenu === 'vouchers' ? 'text-(--button-green)' : 'text-gray-500'
                }`}
            >
              {t('menu.vouchers')}
            </p>
          </span>

          <span
            className={`flex flex-col gap-1 flex-1 items-center p-[7px_0] ${selectedMenu === 'profile' ? 'border-b-4 border-(--button-green)' : ''
              }`}
            onClick={() => {
              onClickMenu('profile')
              submitDatalayerEvent('profile')
              dispatch(operations.dispatchSelectedMenu('profile'))
            }}
          >
            <IoSettingsOutline
              className="text-3xl m-auto text-primary"
              color={selectedMenu === 'profile' ? 'var(--button-green)' : 'gray'}
            />
            <p
              className={`m-0 p-0 font-bold text-[10px] text-center ${selectedMenu === 'profile' ? 'text-(--button-green)' : 'text-gray-500'
                }`}
            >
              {t('menu.profile')}
            </p>
          </span>
        </div>
      </div>
    </>
  )
}

export default withRouter(Footer)